import hr from './hr.js'
import en from './en.js'

export default class Languages {
	static translations = {
		en: en.translations,
		hr: hr.translations
	}
}
